import { logToDataLayer } from './LogHelper';

export const flightClassInfoClick = () => {
  logToDataLayer({
    event: 'Flight class',
  });
};

export const luggageInfoClick = () => {
  logToDataLayer({
    event: 'Luggage',
  });
};

export const priceInfoClick = () => {
  logToDataLayer({
    event: 'Details',
  });
};

export const flightInfoClick = () => {
  logToDataLayer({
    event: 'Flight info',
  });
};

export const changeSortOrder = (sortBy) => {
  let logValue = '';
  switch (sortBy) {
    case 'LOWEST_PRICE':
      logValue = 'LP';
      break;
    case 'RECOMMENDED':
      logValue = 'Y';
      break;
    case 'FASTEST':
      logValue = 'F';
      break;
    default:
      logValue = '';
      break;
  }
  logToDataLayer({
    sortOrder: logValue,
    event: 'Sort order',
  });
};

export const filterBtnClick = () => {
  logToDataLayer({
    event: 'Filter button',
  });
};

export const showFilteredTripsClick = () => {
  logToDataLayer({
    event: 'Show filtered trips',
  });
};

export const flightSearch = (loggingData, translatedMessage) => {
  const travelDuration =
    loggingData.travelType === 'IndependentFlightOnly'
      ? parseInt(loggingData.duration, 10) - 1
      : parseInt(loggingData.duration, 10);

  if (loggingData) {
    let searchLog = {
      event: 'Search',
      title: document.title,
      travelAction: 'Search',
      travelAdults: loggingData.adults,
      travelAges: loggingData.ages,
      travelChildren: loggingData.children,
      travelCountryCode: loggingData.countryCode,
      travelDepartureCode: loggingData.departureAirportCode,
      travelDepartureDay: loggingData.departureDay,
      travelDepartureMonth: loggingData.departureMonth,
      travelDepartureYear: loggingData.departureYear,
      travelDestinationCode: loggingData.destinationAirportCode,
      travelDuration,
      travelHits: loggingData.hits,
      travelPax: loggingData.pax,
      travelPrice: loggingData.maxPrice,
      travelType: loggingData.searchType,
    };
    // FlightOnly does not have below values so they are added if not null
    searchLog = Object.assign(
      searchLog,
      loggingData.travelResortCode && {
        travelResortCode: loggingData.travelResortCode,
      },
    );

    if (translatedMessage && translatedMessage.severity !== 'information') {
      const searchError = `${translatedMessage.errorCode}:${translatedMessage.program}:${translatedMessage.systemId}`;
      searchLog.error = searchError;
      logToDataLayer({
        error: searchError,
        event: 'CA error',
      });
    }

    logToDataLayer(searchLog);
  }
};

export const filterChange = (loggingData, filterValue, filterCategory, filterHits) => {
  const travelDuration =
    loggingData.travelType === 'IndependentFlightOnly'
      ? parseInt(loggingData.duration, 10) - 1
      : parseInt(loggingData.duration, 10);

  if (loggingData) {
    const filterLog = {
      event: 'Filter',
      travelAction: 'Filter',
      travelAdults: loggingData.adults,
      travelAges: loggingData.ages,
      travelChildren: loggingData.children,
      travelCountryCode: loggingData.countryCode,
      travelDepartureCode: loggingData.departureAirportCode,
      travelDepartureDay: loggingData.departureDay,
      travelDepartureMonth: loggingData.departureMonth,
      travelDepartureYear: loggingData.departureYear,
      travelDestinationCode: loggingData.destinationAirportCode,
      travelDuration,
      travelHits: filterHits,
      travelPax: loggingData.pax,
      travelType: loggingData.searchType,
      travelFilterCategory: filterCategory,
      travelFilterValue: filterValue.charAt(0).toUpperCase() + filterValue.slice(1), // First letter needs to be in upper case.
      travelFilterSet: 'Flight list',
    };
    logToDataLayer(filterLog);
  }
};
